import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'

const AURAAgenticAIKeyFeatures = () => {
  return (
    <>
      <Element
        name="AURAAgenticAIKeyFeatures"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "Key Features of AURA Agents"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">Designed for critical industry needs and reliable operations.</p>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4">
              <div className="mea-key-features-card p-4 h-100 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/rocket.svg`} alt="rocket" />
                </div>
                <h5 className="mt-3 mb-3">Ready-to-Deploy</h5>
                <p className="mb-0">Launch pre-built agents for common problems without custom code.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/server.svg`} alt="server" />
                </div>
                <h5 className="mt-3 mb-3">Edge + Cloud Compatible</h5>
                <p className="mb-0">Run agents fully on the edge—or in hybrid mode synchronizing with cloud analytics.</p>
              </div>
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/hexagon.svg`} alt="hexagon" />
                </div>
                <h5 className="mt-3 mb-3">Secure & Private</h5>
                <p className="mb-0">Keep sensitive data local with full auditability and regulatory compliance.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-3 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/brain.svg`} alt="brain" />
                </div>
                <h5 className="mt-3 mb-3">Sector-Tailored</h5>
                <p className="mb-0">Maritime, Seafood, Energy & Public Sector agents ready or easily configured for your needs.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AURAAgenticAIKeyFeatures;